import { ANALYTICS_PROPERTY } from '@kouto/types';
import { AnalyticsDataObserver, analyticsManager } from 'features/analytics';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const CART_DATA_KEY = ANALYTICS_PROPERTY.CartExperiencesSubtotalByPriceTier;

export const useAnalyticsReadyForCartData = () => {
  const [ready, setReady] = useState(false);

  const location = useLocation();

  // Re-seed on every navigation from the CURRENT appData rather than blindly resetting to
  // false. The cart subtotal is usually set on an earlier step (participant/cart page) and
  // persists in appData, and the observer below only fires on a *change*. Without seeding,
  // landing on a page like checkout — where the subtotal doesn't change again — would leave
  // `ready` stuck false, so page-view events gated on it (e.g. VIEW_CHECKOUT) never fire.
  useEffect(() => {
    setReady(CART_DATA_KEY in analyticsManager.getAppData());
  }, [location]);

  useEffect(() => {
    const analyticsObserver: AnalyticsDataObserver = (_appData, newPayload) => {
      if (CART_DATA_KEY in newPayload) {
        setReady(true);
      }
    };

    const removeObserver = analyticsManager.addDataObserver(analyticsObserver);

    return () => {
      removeObserver();
    };
  }, []);

  return ready;
};
